import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    thankyou: {
        width:'100%',
        height: '60vh',
        marginTop: '20vh',
    },
}));

const ThankYou = () => {
    const classes = useStyles();

    return (
        <Container>
            <div className={classes.thankyou}>
                <div>
                    <p>Thank You for supporting Stedman for Senate</p>
                </div>
            </div>
        </Container>
    )
}

export default ThankYou;
